import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './styles/tokens.css'
import './index.css'
import './styles/a11y.css'
import { initGA4Tracking, enhanceLinks } from '@/lib/ga4'
import { bindContactLinks } from '@/lib/analytics'
import GA4PageTracker from './components/GA4PageTracker'
import { Databuddy } from '@databuddy/sdk/react'

// Import accessibility testing utilities for development
if (import.meta.env.DEV) {
  import('./test/a11y.test.ts');
  import('./dev/oneH1Guard.ts');
}

// Initialize service worker for performance and caching (prod only)
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('[SW] Service Worker registered successfully:', registration.scope);
      })
      .catch((error) => {
        console.log('[SW] Service Worker registration failed:', error);
      });
  });
}

// In dev, make sure any old service worker is cleared to avoid stale caches
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
  if ('caches' in window) {
    caches.keys().then((keys) => keys.forEach((key) => caches.delete(key)));
  }
}

  // Initialize GA4 tracking
const initializeAnalytics = () => {
  // Initialize link tracking
  enhanceLinks();
  
  // Initialize interactive tracking
  initGA4Tracking();

  // Auto-track mailto/tel contact clicks
  bindContactLinks();
  
  console.log('[GA4] Analytics initialized with Measurement ID: G-HXSXMFRTEN');
};

// Run analytics initialization
if (typeof window !== 'undefined') {
  initializeAnalytics();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <GA4PageTracker />
        <>
          <App />
          <Databuddy
            clientId="646a76ef-56ec-4e99-a9a3-e931d651a548"
            trackHashChanges={true}
            trackAttributes={true}
            trackOutgoingLinks={true}
            trackInteractions={true}
            trackScrollDepth={true}
            trackWebVitals={true}
            trackErrors={true}
          />
        </>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
)
